import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icons';
import { YOUTUBE_CHANNEL } from '../../data/social';
import LuxReveal from './LuxReveal';

const resources = [
  {
    icon: 'play',
    title: 'Free PLC & SCADA Tutorials',
    desc: 'Concept videos, ladder logic basics, and industry tips on our YouTube channel.',
    href: YOUTUBE_CHANNEL,
    tag: 'YouTube',
  },
  {
    icon: 'factory',
    title: 'Visit Our Noida Lab',
    desc: 'See real equipment, meet trainers, and understand which course fits your career goal.',
    href: '/contact',
    tag: 'Book visit',
    internal: true,
  },
  {
    icon: 'graduation',
    title: 'Admission Counselling',
    desc: 'Talk to our team about fees, batches, EMI options, and placement support — free of cost.',
    href: '/admission',
    tag: 'Apply free',
    internal: true,
  },
  {
    icon: 'trophy',
    title: 'Placement Success Stories',
    desc: '500+ alumni placed at Siemens, ABB, TCS, Infosys and more manufacturing & IT firms.',
    href: '/placements',
    tag: 'View placements',
    internal: true,
  },
];

export default function LearnResources() {
  return (
    <section className="lux-resources">
      <div className="video-gallery__header container-wide">
        <LuxReveal>
          <p className="lux-statement__eyebrow">Resources</p>
          <h2 className="video-gallery__title">
            Learn &amp; connect<br />
            <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>with us</em>
          </h2>
        </LuxReveal>
        <LuxReveal delay={0.1}>
          <a href={YOUTUBE_CHANNEL} target="_blank" rel="noreferrer" className="btn-lux btn-lux--line" style={{ color: 'var(--text)' }}>
            <Icon name="play" size={16} /> YouTube Channel
          </a>
        </LuxReveal>
      </div>

      <div className="lux-resources__grid container-wide">
        {resources.map((r, i) => {
          const inner = (
            <>
              <span className="lux-resource-card__tag">{r.tag}</span>
              <div className="icon-wrap" style={{ width: 48, height: 48, marginBottom: 20 }}>
                <Icon name={r.icon} size={22} />
              </div>
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
              <span className="lux-resource-card__link">
                Explore <Icon name="arrowRight" size={14} />
              </span>
            </>
          );
          return (
            <LuxReveal key={r.title} delay={i * 0.08}>
              {r.internal ? (
                <motion.div whileHover={{ y: -6 }} transition={{ duration: 0.35 }}>
                  <Link to={r.href} className="lux-resource-card">{inner}</Link>
                </motion.div>
              ) : (
                <motion.a
                  href={r.href}
                  target="_blank"
                  rel="noreferrer"
                  className="lux-resource-card"
                  whileHover={{ y: -6 }}
                  transition={{ duration: 0.35 }}
                >
                  {inner}
                </motion.a>
              )}
            </LuxReveal>
          );
        })}
      </div>
    </section>
  );
}
